export default __webpack_public_path__ + "static/media/question-mark-rounded.fcb2e04a.svg";